import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { StyledMediaItem } from "./media-item-component.scss";
const MediaItem = ({ backgroundColor, title, description, icon, direction })=>{
    return /*#__PURE__*/ _jsxs(StyledMediaItem, {
        className: classnames("media-item--wrapper", direction),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "media-item--icon-wrapper",
                style: {
                    backgroundColor
                },
                children: /*#__PURE__*/ _jsx("img", {
                    className: "media-item--icon",
                    src: icon,
                    alt: title
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "media-item--text",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "media-item--title",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "media-item--subtitle",
                        children: description
                    })
                ]
            })
        ]
    });
};
MediaItem.defaultProps = {};
export default MediaItem;
